import { useQuery } from "@apollo/client/react";
import type { SkynetUserGroup } from "../../../models/RolesAndPermissionsModels";
import GET_USER_GROUP from "../../queries/rolesAndPermissions/getUserGroup";

export const useUserGroup = (id?: string) => {
  const { data, error, loading, refetch } = useQuery<{
    userGroup: SkynetUserGroup;
  }>(GET_USER_GROUP, {
    skip: !id,
    variables: {
      id,
    },
  });
  return { userGroup: data?.userGroup, error, loading, refetch };
};
